import {
  Box,
  FormLabel,
  HStack,
  Icon,
  Input,
  SimpleGrid,
  Stack,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { MdInfoOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";

import { getPaymentSubjectRequest } from "../../../../modules/admin-modules/videos/Actions";

const LabelWithHint = ({ children, hint }) => (
  <HStack spacing="6px" mb="2" alignItems="center">
    <FormLabel mb="0">{children}</FormLabel>
    {hint && (
      <Tooltip
        label={hint}
        hasArrow
        placement="top"
        bg="gray.700"
        color="white"
        borderRadius="8px"
        px="3"
        py="2"
        fontSize="sm"
        maxW="260px"
        textAlign="right"
      >
        <Box as="span" display="inline-flex" cursor="help" color="gray.500">
          <Icon as={MdInfoOutline} boxSize="18px" />
        </Box>
      </Tooltip>
    )}
  </HStack>
);

const SettingCard = ({ title, children }) => (
  <Box
    w="100%"
    bg="#fafafa"
    border="1px solid"
    borderColor="gray.200"
    borderRadius="16px"
    p="20px"
  >
    {title && (
      <Text fontWeight="600" color="main_1" mb="16px" fontSize="16px">
        {title}
      </Text>
    )}
    {children}
  </Box>
);

const StepOne = ({
  data,
  register,
  errors,
  isFormOne,
  watchTimer,
  setValue,
  watchType,
  watch,
  isAdd,
  fixedType,
}) => {
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  const videos = useSelector((state) => state.videos.videos);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPaymentSubjectRequest());
  }, []);

  useEffect(() => {
    if (isAdd && (watchTimer === undefined || watchTimer === null || watchTimer === "")) {
      setValue("timer", "0");
    }
  }, [isAdd, setValue]);

  useEffect(() => {
    if (fixedType != null) {
      setValue("type", String(fixedType));
    }
  }, [fixedType, setValue]);

  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const videosOptions = videos?.map((data) => {
    return { value: data.id, label: data.title };
  });

  return (
    <VStack
      dir="rtl"
      w="100%"
      flexWrap="wrap"
      justifyContent="space-between"
      spacing="24px"
      display={isFormOne ? "flex" : "none"}
      mt="24px"
    >
      <SettingCard title="المعلومات الأساسية">
        <MainInput
          label="عنوان الاختبار"
          defaultValues={data.name}
          error={errors?.name?.message}
          placeholder="ادخل عنوان الاختبار"
          register={register}
          name="name"
        />
      </SettingCard>

      <SettingCard title="إعدادات المؤقت">
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing="20px" w="100%">
          <Box>
            <LabelWithHint hint="حدد ما إذا كان الاختبار بمؤقت زمني أم بدون حد للوقت">
              إضافة مؤقت للاختبار :
            </LabelWithHint>
            <Stack direction="row" spacing="20px">
              <label>
                <input
                  {...register("timer", { required: "هذه المعلومات مطلوبة" })}
                  type="radio"
                  value="0"
                  defaultChecked={
                    isAdd ? true : data?.timer == 0 || data?.timer == "0"
                  }
                />
                {" "}لا
              </label>
              <label>
                <input
                  {...register("timer", { required: "هذه المعلومات مطلوبة" })}
                  type="radio"
                  value="1"
                  defaultChecked={!isAdd && (data?.timer == 1 || data?.timer == "1")}
                />
                {" "}نعم
              </label>
              <Text color="red">{errors?.timer?.message}</Text>
            </Stack>
          </Box>

          {(watchTimer == 1 || watchTimer == "1") && (
            <Box>
              <LabelWithHint hint="المدة بالدقائق المتاحة للطالب لإكمال الاختبار">
                زمن مؤقت :
              </LabelWithHint>
              <MainInput
                label=""
                required={false}
                defaultValues={data.time}
                placeholder="ادخل زمن الاختبار"
                register={register}
                name="time"
              />
            </Box>
          )}
        </SimpleGrid>
      </SettingCard>

      <SettingCard title="موعد الاختبار">
        <Text fontSize="13px" color="gray.600" mb="16px">
          التوقيت بتوقيت القاهرة (UTC+3)، بغض النظر عن توقيت جهازك.
        </Text>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing="20px" w="100%">
          <Box>
            <LabelWithHint hint="يظهر للطالب العد التنازلي حتى هذا الوقت. اتركه فارغاً إذا كان الاختبار متاحاً فوراً">
              تاريخ البداية
            </LabelWithHint>
            <Input
              type="datetime-local"
              {...register("start_date")}
              bg="#f5f5f5"
              borderRadius="16px"
            />
          </Box>
          <Box>
            <LabelWithHint hint="يظهر للطالب الوقت المتبقي حتى إغلاق الاختبار. اتركه فارغاً إذا لم يكن هناك موعد إغلاق">
              تاريخ النهاية
            </LabelWithHint>
            <Input
              type="datetime-local"
              {...register("end_date")}
              bg="#f5f5f5"
              borderRadius="16px"
            />
          </Box>
        </SimpleGrid>
      </SettingCard>

      <SettingCard title="حالة الظهور والتفعيل">
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing="20px" w="100%">
          <Box>
            <LabelWithHint hint="عند النشر يظهر الاختبار للطلاب في لوحة المحتوى">
              نشر الاختبار :
            </LabelWithHint>
            <Stack direction="row" spacing="16px" flexWrap="wrap">
              <label>
                <input
                  {...register("published", {
                    required: "هذه المعلومات مطلوبة",
                  })}
                  type="radio"
                  value="0"
                  defaultChecked={
                    isAdd ? true : data?.published == 0 ? true : false
                  }
                />
                {" "}نشر الاختبار
              </label>
              <label>
                <input
                  {...register("published", {
                    required: "هذه المعلومات مطلوبة",
                  })}
                  type="radio"
                  value="1"
                  defaultChecked={data?.published == 1 ? true : false}
                />
                {" "}عدم نشر الاختبار
              </label>
              <Text color="red">{errors?.published?.message}</Text>
            </Stack>
          </Box>

          <Box>
            <LabelWithHint hint="تفعيل الاختبار يسمح للطلاب بدخوله وأداءه">
              تفعيل الاختبار :
            </LabelWithHint>
            <Stack direction="row" spacing="16px" flexWrap="wrap">
              <label>
                <input
                  {...register("enable", {
                    required: "هذه المعلومات مطلوبة",
                  })}
                  type="radio"
                  value="0"
                  defaultChecked={isAdd ? true : data?.enable == 0 ? true : false}
                />
                {" "}تفعيل الاختبار
              </label>
              <label>
                <input
                  {...register("enable", {
                    required: "هذه المعلومات مطلوبة",
                  })}
                  type="radio"
                  value="1"
                  defaultChecked={data?.enable == 1 ? true : false}
                />
                {" "}عدم تفعيل الاختبار
              </label>
              <Text color="red">{errors?.enable?.message}</Text>
            </Stack>
          </Box>

          <Box>
            <LabelWithHint hint="هل تظهر نتيجة الاختبار للطالب تلقائياً بعد التسليم؟">
              نشر نتيجة الاختبار :
            </LabelWithHint>
            <Stack direction="row" spacing="16px" flexWrap="wrap">
              <label>
                <input
                  {...register("auto_publish_result", {
                    required: "هذه المعلومات مطلوبة",
                  })}
                  type="radio"
                  value="1"
                  defaultChecked={
                    data?.auto_publish_result == 1 ? true : false
                  }
                />
                {" "}نشر النتيجة
              </label>
              <label>
                <input
                  {...register("auto_publish_result", {
                    required: "هذه المعلومات مطلوبة",
                  })}
                  type="radio"
                  value="0"
                  defaultChecked={
                    isAdd
                      ? true
                      : data?.auto_publish_result == 0
                        ? true
                        : false
                  }
                />
                {" "}عدم نشر النتيجة
              </label>
              <Text color="red">{errors?.auto_publish_result?.message}</Text>
            </Stack>
          </Box>

          <Box>
            <LabelWithHint hint="هل يمكن للطالب طلب إعادة أداء الاختبار؟">
              متاح للإعادة redo؟
            </LabelWithHint>
            <Stack direction="row" spacing="16px" flexWrap="wrap">
              <label>
                <input
                  {...register("redo_flag", {
                    required: "هذه المعلومات مطلوبة",
                  })}
                  type="radio"
                  value="1"
                  defaultChecked={data?.redo_flag == 1 ? true : false}
                />
                {" "}تفعيل الاعادة
              </label>
              <label>
                <input
                  {...register("redo_flag", {
                    required: "هذه المعلومات مطلوبة",
                  })}
                  type="radio"
                  value="0"
                  defaultChecked={
                    isAdd ? true : data?.redo_flag == 0 ? true : false
                  }
                />
                {" "}عدم تفعيل الاعادة
              </label>
              <Text color="red">{errors?.redo_flag?.message}</Text>
            </Stack>
          </Box>
        </SimpleGrid>
      </SettingCard>

      <SettingCard title="نوع الاختبار ودرجة الصعوبة">
        <Box mb="20px">
          <LabelWithHint hint="اختر نوع المحتوى: اختبار، واجب، اختبار فيديو، أو اختبار سنتر">
            نوع الاختبار :
          </LabelWithHint>
          <Stack direction="row" spacing="20px" flexWrap="wrap">
            {fixedType != null ? (
              <label style={{ pointerEvents: "none" }}>
                <input
                  {...register("type", { required: "هذه المعلومات مطلوبة" })}
                  type="radio"
                  value={String(fixedType)}
                  defaultChecked
                />
                {" "}اختبار ورقي للسنتر
              </label>
            ) : (
              <>
                <label>
                  <input
                    {...register("type", { required: "هذه المعلومات مطلوبة" })}
                    type="radio"
                    value="1"
                    defaultChecked={isAdd ? true : data?.type == 1 ? true : false}
                  />
                  {" "}اختبار
                </label>
                <label>
                  <input
                    {...register("type", { required: "هذه المعلومات مطلوبة" })}
                    type="radio"
                    value="2"
                    defaultChecked={data?.type == 2 ? true : false}
                  />
                  {" "}واجب
                </label>
                <label>
                  <input
                    {...register("type", { required: "هذه المعلومات مطلوبة" })}
                    type="radio"
                    value="6"
                    defaultChecked={data?.type == 6 ? true : false}
                  />
                  {" "}اختبار لفيديو
                </label>
                <label>
                  <input
                    {...register("type", { required: "هذه المعلومات مطلوبة" })}
                    type="radio"
                    value="7"
                    defaultChecked={data?.type == 7 ? true : false}
                  />
                  {" "}Asquera Practice{" "}
                </label>
                <label>
                  <input
                    {...register("type", { required: "هذه المعلومات مطلوبة" })}
                    type="radio"
                    value="5"
                    defaultChecked={data?.type == 5 ? true : false}
                  />
                  {" "}اختبار ورقي للسنتر
                </label>
              </>
            )}
            <Text color="red">{errors?.type?.message}</Text>
          </Stack>
        </Box>

        {watchType == 6 && (
          <Box mb="20px">
            <LabelWithHint hint="اختر الفيديو المرتبط بهذا الاختبار">
              اختر الفيديو :
            </LabelWithHint>
            <Select
              options={videosOptions}
              isMulti={false}
              onChange={(selected) => {
                setValue("video_id", selected?.value || "");
              }}
              styles={colourStyles}
              placeholder="الفيديو"
              value={
                videosOptions?.find(
                  (option) =>
                    String(option.value) === String(watch("video_id"))
                ) ||
                (data?.video
                  ? { label: data.video.title, value: data.video.id }
                  : null)
              }
            />
          </Box>
        )}

        <Box>
          <LabelWithHint hint="حدد مستوى صعوبة الأسئلة المعروضة في هذا الاختبار">
            درجة صعوبة الامتحان :
          </LabelWithHint>
          <Stack direction="row" spacing="20px" flexWrap="wrap">
            <label>
              <input
                {...register("difficulty")}
                type="radio"
                value="0"
                defaultChecked={
                  isAdd ? true : data?.difficulty == 0 ? true : false
                }
              />
              {" "}all
            </label>
            <label>
              <input
                {...register("difficulty")}
                type="radio"
                value="1"
                defaultChecked={data?.difficulty == 1 ? true : false}
              />
              {" "}notes
            </label>
            <label>
              <input
                {...register("difficulty")}
                type="radio"
                value="2"
                defaultChecked={data?.difficulty == 2 ? true : false}
              />
              {" "}Studing and remebering
            </label>
            <label>
              <input
                {...register("difficulty")}
                type="radio"
                value="3"
                defaultChecked={data?.difficulty == 3 ? true : false}
              />
              {" "}Hard and challenging
            </label>
            <label>
              <input
                {...register("difficulty")}
                type="radio"
                value="4"
                defaultChecked={data?.difficulty == 4 ? true : false}
              />
              {" "}Previous exams
            </label>
            <label>
              <input
                {...register("difficulty")}
                type="radio"
                value="5"
                defaultChecked={data?.difficulty == 5 ? true : false}
              />
              {" "}Revision
            </label>
          </Stack>
        </Box>
      </SettingCard>

      <SettingCard title="الدفع ودرجة النجاح">
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing="20px" w="100%">
          <Box>
            <LabelWithHint hint="المادة المرتبطة بدفع هذا الاختبار (إن وُجدت)">
              الدفع المرتبط بالاختبار :
            </LabelWithHint>
            <Select
              options={paymentSubjectsOptions}
              isMulti={false}
              onChange={(selected) => {
                setValue("payment_subject_id", selected?.value || "");
              }}
              styles={colourStyles}
              placeholder="الدفع المرتبط بالاختبار"
              value={
                paymentSubjectsOptions?.find(
                  (option) =>
                    String(option.value) ===
                    String(watch("payment_subject_id"))
                ) || null
              }
            />
          </Box>
          <Box>
            <LabelWithHint hint="الحد الأدنى للدرجة لاعتبار الطالب ناجحاً في الاختبار">
              درجة النجاح :
            </LabelWithHint>
            <Input
              {...register("success_score", { required: false })}
              type="number"
              placeholder="ادخل درجة النجاح"
              defaultValue={data?.success_score}
              bg="#f5f5f5"
              borderRadius="16px"
            />
          </Box>
        </SimpleGrid>
      </SettingCard>
    </VStack>
  );
};

export default StepOne;
